import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';

import { useMessagesFeedStore } from './useMessagesFeedStore';

export const MessagesRequester: FC<{ children: ReactElement }> = ({
  children,
}) => {
  // Trigger an initial feed fetch once the REAL Knock client is available.
  //
  // The store starts with an inert no-op client; `KnockFeedBridge` swaps in the
  // real `feedClient` from its own effect. This component renders as a CHILD of
  // that bridge, and React runs passive effects bottom-up (child before parent),
  // so a mount-only `fetch()` runs BEFORE the bridge has set the real client — it
  // hits the no-op and fetches nothing, and (depending on the stable `fetch`
  // action) never retries, leaving the feed empty for the whole session (flaky:
  // it only worked when Knock's own auto-fetch happened to fire). Depending on
  // `client` re-runs this effect when the real client lands, guaranteeing a fetch.
  const client = useMessagesFeedStore((state) => state.client);
  useEffect(() => {
    client.fetch();
  }, [client]);

  return children;
};
